import React from 'react';
import './noResults.scss';
import NotificationImage from '../../../../src/assets/images/notification_image.png';
import worksImage from '../../../../src/assets/images/works_icon2.svg';
import catalogImage from '../../../../src/assets/images/catalog_icon2.svg';
import notVerified from '../../../../src/assets/images/not_verified_icon.svg'
import transactionIcon from '../../../../src/assets/images/transaction_empty_icon.svg'
import notificationIcon from '../../../../src/assets/images//notification_nodata_icon.svg'
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NoResults = ({ title, description, children, type , className }) => {
    const navigate = useNavigate();

    const imageSrc = () => {
        switch (type) {
            case 'ad':
                return NotificationImage;
            case 'works':
                return worksImage;
            case 'catalog':
                return catalogImage
            case 'business_info':
                return notVerified
            case 'transaction':
                return transactionIcon
            case 'notification':
                return notificationIcon
            default:
                return null; // or any default image you want to return
        }
    };

    return (
        <div className={`  text-center no_ad ${className} ${type}`} style={{ width: "100%" }}>
            {
                type && (
                    <figure>
                        <img src={imageSrc()} className='img_full contain' alt="" />
                    </figure>
                )
            }

            <div className='noresults_content'>
                <h3 className='text_red text_md mb-0'>{title}</h3>
                {description && <p style={{ lineHeight: "1.5" }}>{description}</p>}
                {children}
            </div>
        </div>
    );
}

export default NoResults;
